import { anchorStyles } from '../../components/anchor/anchor.styles.esm.js';
import { avatarStyles } from '../../components/avatar/avatar.styles.esm.js';
import { bannerStyles } from '../../components/banner/banner.styles.esm.js';
import { buttonStyles } from '../../components/button/button.styles.esm.js';
import { cardStyles } from '../../components/card/card.styles.esm.js';
import { checkboxStyles } from '../../components/checkbox/checkbox.styles.esm.js';
import { comboBoxStyles } from '../../components/combo-box/combo-box.styles.esm.js';
import { dialogFooterStyles } from '../../components/modal/dialog-footer/dialog-footer.styles.esm.js';
import { dividerStyles } from '../../components/divider/divider.styles.esm.js';
import { gridListItemStyles } from '../../components/collections/grid-list-item.styles.esm.js';
import { fieldGroupStyles } from '../../components/field/field-group/field-group.styles.esm.js';
import { imageStyles } from '../../components/image/image.styles.esm.js';
import { infoCardStyles } from '../../components/info-card/info-card.styles.esm.js';
import { inputStyles } from '../../components/field/input/input.styles.esm.js';
import { labelStyles } from '../../components/field/label/label.styles.esm.js';
import { listBoxItemStyles } from '../../components/collections/list-box-item.styles.esm.js';
import { logoStyles } from '../../components/logo/logo.styles.esm.js';
import { modalStyles } from '../../components/modal/primitives/modal.styles.esm.js';
import { radioStyles } from '../../components/radio/styles/radio.styles.esm.js';
import { segmentedControlStyles } from '../../components/segmented-control/styles/segmented-control.styles.esm.js';
import { selectStyles } from '../../components/select/select.styles.esm.js';
import { skeletonStyles } from '../../components/skeleton/skeleton.styles.esm.js';
import { spinnerStyles } from '../../components/spinner/spinner.styles.esm.js';
import { switchStyles } from '../../components/switch/switch.styles.esm.js';
import { tagInnerStyles } from '../../components/tag/tag-inner.styles.esm.js';
import { tagGroupStyles } from '../../components/tag/tag-group.styles.esm.js';
import { textStyles } from '../../components/text/text.styles.esm.js';
import { textAreaStyles } from '../../components/field/text-area/text-area.styles.esm.js';
import { textFieldStyles } from '../../components/field/text-field/text-field.styles.esm.js';
import { toggleButtonGroupStyles } from '../../components/button/toggle-button-group.styles.esm.js';
import { toastStyles } from '../../components/toast-content/toast.styles.esm.js';
import { treeStyles } from '../../components/tree/tree.styles.esm.js';

var baseTheme = {
  components: {
    Anchor: anchorStyles.base,
    Avatar: avatarStyles.base,
    Banner: bannerStyles.base,
    Button: buttonStyles.base,
    Card: cardStyles.base,
    Checkbox: checkboxStyles.base,
    ComboBox: comboBoxStyles.base,
    DialogFooter: dialogFooterStyles.base,
    Divider: dividerStyles.base,
    DropdownItem: gridListItemStyles.base,
    FieldGroup: fieldGroupStyles.base,
    Image: imageStyles.base,
    InfoCard: infoCardStyles.base,
    Input: inputStyles.base,
    Label: labelStyles.base,
    ListBoxItem: listBoxItemStyles.base,
    Logo: logoStyles.base,
    Modal: modalStyles.base,
    Radio: radioStyles.base,
    SegmentedControl: segmentedControlStyles.base,
    Select: selectStyles.base,
    Skeleton: skeletonStyles.base,
    Spinner: spinnerStyles.base,
    Switch: switchStyles.base,
    Tag: tagInnerStyles.base,
    TagGroup: tagGroupStyles.base,
    Text: textStyles.base,
    TextArea: textAreaStyles.base,
    TextField: textFieldStyles.base,
    ToggleButtonGroup: toggleButtonGroupStyles.base,
    Toast: toastStyles.base,
    Tree: treeStyles.base
  }
};
var baseTheme$1 = baseTheme;

export { baseTheme$1 as default };
//# sourceMappingURL=base.esm.js.map
